<template>
  <Card
    class="col-span-12 md:col-span-3 motion-safe:animate-fadeIn group bg-white !rounded-2xl !shadow-md hover:!shadow-xl transition-all duration-200 overflow-hidden cursor-default"
  >
    <template #header>
      <div class="relative">
        <img
          :src="course?.file?.url || emptyImg"
          @error="imgDefaultError"
          class="w-full h-48 object-cover transform group-hover:scale-105 transition-transform duration-200"
          style="height: 13rem"
          loading="lazy"
        />
        <span
          :class="`${utils.getStatusColor(
            course?.status!
          )} absolute top-4 right-4 px-2 py-1 text-xs rounded-full font-bold shadow-md`"
          v-if="stats === false"
        >
          {{ utils.getStatus(course?.status!) }}
        </span>
      </div>
    </template>

    <template #title>
      <div
        class="flex text-h-primary-500 justify-between items-center hover:cursor-pointer hover:text-h-secondary-600"
        :title="course?.name"
        @click="onEdit(course)"
      >
        <h5 class="truncate max-w-fit">
          {{ course?.name }}
        </h5>
        <v-icon
          :name="`${
            user.role == 'TEACHER' ? 'hi-solid-pencil' : 'hi-solid-eye'
          }`"
          class="text-h-primary-500 cursor-pointer hover:scale-125"
          @click="onEdit(course)"
          v-if="stats === false"
        />
      </div>
    </template>

    <template #subtitle v-if="stats === false">
      <p class="text-gray-400">
        {{ $t("labels.generic", { pt: "Duração: ", en: "Duration: " }) }}
        {{ generics.getDurationTime(course?.duration!) }}
      </p>
    </template>
    <template #content v-if="stats"></template>
    <template #content v-else>
      <p class="line-clamp-2 text-gray-600">
        {{ course?.description }}
      </p>
    </template>

    <template #footer v-if="course?.status !== 'PUBLISHED' && stats === false">
      <div class="flex justify-end gap-3">
        <div
          class="flex justify-end gap-3"
          v-if="course?.status == 'REPROVED' && user.role == 'TEACHER'"
        >
          <Button
            :label="$t('labels.generic', { pt: 'Ver mais', en: 'More' })"
            class="btn-outline p-button-sm"
            @click="onSeeMore(course)"
          />
          <Button
            :label="
              $t('labels.generic', { pt: 'Enviar novamente', en: 'Send again' })
            "
            class="btn-primary p-button-sm"
            @click="onSendToApprove(course)"
          />
        </div>
        <Button
          v-if="course?.status == 'APPROVED'"
          :label="$t('labels.generic', { pt: 'Publicar', en: 'Publish' })"
          class="btn-primary p-button-sm"
          @click="onPublish(course)"
        />
        <Button
          v-if="course?.status == 'NOT_PUBLISHED' && user.role == 'TEACHER'"
          :label="
            $t('labels.generic', {
              pt: 'Enviar para aprovação',
              en: 'Send to approve',
            })
          "
          class="btn-outline p-button-sm"
          @click="onSendToApprove(course)"
        />
        <Button
          v-if="course?.status == 'WAITING' && user.role == 'ADMINISTRATOR'"
          :label="
            $t('labels.generic', {
              pt: 'Reprovar',
              en: 'To reprove',
            })
          "
          class="btn-outline p-button-sm"
          @click="onReprove(course)"
        />
        <Button
          v-if="course?.status == 'WAITING' && user.role == 'ADMINISTRATOR'"
          :label="
            $t('labels.generic', {
              pt: 'Aprovar',
              en: 'To approve',
            })
          "
          class="btn-primary p-button-sm"
          @click="onApprove(course)"
        />
      </div>
    </template>
  </Card>
</template>

<script lang="ts">
import { GenericsUtils } from "@/utils/generics.util";
import { defineComponent, PropType } from "vue";
import { CardUtils } from "./utils";
import { getUserFromStorage } from "@/utils/user-store.util";
import { Course, CourseType } from "@/models/courses.model";

export default defineComponent({
  name: "cardCourse",
  computed: {
    utils(): CardUtils {
      return new CardUtils();
    },
    generics(): GenericsUtils {
      return new GenericsUtils();
    },
    user(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      emptyImg:
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png" as string,
    };
  },
  emits: [
    "onSeeMore",
    "onSendToApprove",
    "onPublish",
    "onEdit",
    "onApprove",
    "onReprove",
  ],
  props: {
    course: Object as PropType<Course>,
    stats: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    imgDefaultError(e: any): void {
      e.target.src =
        "https://video-thumb.s3.sa-east-1.amazonaws.com/65197bdbplaceholder.png";
    },
    onSeeMore(data: any): void {
      this.$emit("onSeeMore", data);
    },
    onSendToApprove(data: any): void {
      this.$emit("onSendToApprove", data);
    },
    onPublish(data: any): void {
      this.$emit("onPublish", data);
    },
    onEdit(data: any): void {
      this.$emit("onEdit", data);
    },
    onApprove(data: Course): void {
      this.$emit("onApprove", data, this.handleCourseType(data));
    },
    onReprove(data: any): void {
      this.$emit("onReprove", data, "toReprove");
    },
    handleCourseType(course: Course): string {
      const typeMap: { [key: string]: string } = {
        [CourseType.ADAPTATIVE]: "toApprove",
        [CourseType.INTERACTIVE]: "toApproveInteractive",
      };
      const typeKey = course?.type ? String(course.type) : "";
      return typeMap[typeKey] || "toApproveTraditional";
    },
  },
});
</script>
